<template>
  <SectionLayout :section-title="sectionTitle" is-paging :current-page="currentPage" :total-pages="totalPages" @paging="moveToPage" section-key="newTemplates" :loading="loadingDashboard">
    <template #default>
      <div class="page-block-list overflow-hidden pt-2 pl-1 pr-1 mt-n2">
        <div class="row slide__list" :style="listDynamicStyle" v-if="allTemplates.length">
          <PageTemplateItem no-margin-top for-dashboard :shopIsPro="shopIsPro" :hidePrimary="notAllowCreate" :primaryAction="onCreateNewPage" :secondaryAction="openPreview" v-for="(item, index) in allTemplates" :number-per-page="numberPerPage" :key="`tmpl_${index}`" :item="item" />
        </div>
      </div>
      <PreviewTemplate v-if="showPreview" :template="templateId" @close="closePreview" :list="allTemplates" :hideEdit="notAllowCreate" @select="onCreateNewPage" />
      <ModalCreatePage v-if="showCreatePage" :shop="shopifyDomain" :template.sync="templateId" type="subpages" @close="closeCreatePage" />
    </template>
    <!-- <template #pagingAction>
      <router-link replace :to="{ name: 'Templates' }">
        <div class="section__actions">
          <span class="action-text text-light-high paragraph-12-medium">
            {{ linkTemplateText }}
          </span>
        </div>
      </router-link>
    </template> -->
  </SectionLayout>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SectionLayout from "./SectionLayout.vue";
import { PageTemplateItem } from "@/modules/Shopify/components";
import PreviewTemplate from "@/modules/Shopify/components/PreviewTemplate.vue";
import ModalCreatePage from "@/modules/Shopify/components/ModalCreatePage.vue";
import { getThemeId } from "@/modules/Instant/utils";
import Config from "@/config";
import { pageApi } from "@/services";

export default {
  name: "NewTemplate",
  components: {
    SectionLayout,
    PageTemplateItem,
    PreviewTemplate,
    ModalCreatePage
  },
  data: () => ({
    numberPerPage: 3,
    currentPage: 1,
    templateId: null,
    showPreview: false,
    showCreatePage: false,
    isPaging: false
  }),
  computed: {
    ...mapState("dashboard", {
      templates: "newTemplates",
      loadingDashboard: "loading"
    }),
    ...mapState("account", {
      shopInfo: "shopInfo",
      permissions: "permissions"
    }),
    ...mapGetters("account", {
      accountExpired: "accountExpired",
      shopifyDomain: "shopifyDomain",
      shopIsPro: "shopIsPro"
    }),
    sectionTitle() {
      return this.$t("dashboard.newTemplates");
    },
    linkTemplateText() {
      return this.$t("dashboard.newTemplatesLink");
    },
    allTemplates() {
      if (this.loadingDashboard) {
        return [null, null, null];
      }

      if (this.templates && this.templates.length) {
        let arr = JSON.parse(JSON.stringify(this.templates));
        return arr
          .filter(item => item.type !== "STATIC")
          .sort((template1, template2) => {
            if (template1.status == "new" && template2.status != "new") return -1;
            return 0;
          });
      }
      return [];
    },
    totalPages() {
      return Math.ceil(this.allTemplates.length / this.numberPerPage);
    },
    listDynamicStyle() {
      return {
        transform: `translateX(${-100 * (this.currentPage - 1)}%)`
      };
    },
    notAllowCreate() {
      const notAllow = this.accountExpired || !this.permissions?.subpages;
      return notAllow;
    },
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.shopType && this.shopInfo.shopType.isGemPagesV7) || window.___gemShopInfo.shopType.isGemPagesV7 || false;
    },
    editorV7Url() {
      return Config.getSetting("instantBaseURL") + `/editor/${this.themeId}/${this.page.id}?type=gempagesv7`;
    }
  },
  methods: {
    ...mapActions("page", {
      createPageWithOneTap: "createPageWithOneTap"
    }),
    closePreview() {
      this.showPreview = false;
      this.templateId = null;
    },
    openPreview(id) {
      this.templateId = id;
      this.showPreview = true;
    },
    openCreatePage(id) {
      if (this.permissions?.subpages) {
        this.templateId = id;
        this.showCreatePage = true;
      }
    },
    async onCreateNewPage(templateId) {
      if (this.isGemPagesV7) {
        const themeId = await getThemeId();
        const res = await pageApi.duplicateThemePageApi(templateId, themeId);
        const themePageId = res.data.themePageDuplicate.id;
        return (window.location.href = Config.getSetting("instantBaseURL") + `/editor/${themeId}/${themePageId}?type=gempagesv7`);
      }
      if (this.permissions?.subpages) {
        this.createPageWithOneTap({ type: "subpages", templateId: templateId });
      }
      return false;
    },
    closeCreatePage() {
      this.showCreatePage = false;
      this.templateId = null;
    },
    moveToPage(index) {
      this.currentPage = index;
    }
  }
};
</script>
<style lang="scss" scoped>
.page-block-list {
  margin-left: -4px;
  margin-right: -4px;
}
</style>
